export default "<span>{{countTimer}}</span>\n"